export class InputValidation {
  constructor(message: string) {
    this.messageErro = message
  }

  erro: boolean = false
  messageErro: string = ""
}